import { FC, useState } from 'react';
import loadable from '@loadable/component';
import {
  ReviewCheckToggleButton,
  ReviewCheckToggleContext,
  ReviewCheckToggleContextType,
  ReviewCheckHolder,
} from '#baseMenu/components/controls/middle-button/review-check-toggle';

const ReviewCheck = loadable(() => import('#reviewCheck/containers'), {
  resolveComponent: ({ ReviewCheck: Component }) => Component,
});

const ReviewCheckToggle: FC = () => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [isLoadInProcess, setIsLoadInProcess] = useState<boolean>(false);

  const reviewCheckToggleContextValue: ReviewCheckToggleContextType = {
    ReviewCheck,
    isLoaded,
    setIsLoaded,
    isLoadInProcess,
    setIsLoadInProcess,
  };

  return (
    <ReviewCheckToggleContext.Provider value={reviewCheckToggleContextValue}>
      <ReviewCheckToggleButton />
      <ReviewCheckHolder />
    </ReviewCheckToggleContext.Provider>
  );
};

export { ReviewCheckToggle };
